import { Trade } from "../api";

const statusStyles: Record<string, string> = {
  filled: "text-success",
  closed: "text-fg-muted",
  rejected: "text-danger",
  skipped: "text-fg-muted",
  pending: "text-warn",
};

function fmtTime(s: string | null) {
  if (!s) return "—";
  const d = new Date(s);
  return d.toLocaleTimeString();
}

export function TradesPanel({ trades }: { trades: Trade[] }) {
  return (
    <section className="bg-surface border border-border rounded p-4">
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="text-sm uppercase tracking-wider text-fg-muted">
          Recent trades
        </h2>
        <span className="text-xs text-fg-muted font-mono">
          last {trades.length}
        </span>
      </div>

      {trades.length === 0 ? (
        <p className="text-fg-muted text-sm">no trades yet</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm font-mono">
            <thead className="text-xs uppercase text-fg-muted">
              <tr className="border-b border-border">
                <th className="text-left py-2 pr-3">ID</th>
                <th className="text-left py-2 pr-3">Time</th>
                <th className="text-left py-2 pr-3">Status</th>
                <th className="text-left py-2 pr-3">Symbol</th>
                <th className="text-left py-2 pr-3">Dir</th>
                <th className="text-right py-2 pr-3">Lot</th>
                <th className="text-right py-2 pr-3">Fill</th>
                <th className="text-right py-2 pr-3">Exit</th>
                <th className="text-right py-2 pr-3">P/L</th>
                <th className="text-left py-2 pr-3">MT5 ticket</th>
                <th className="text-left py-2 pr-3">Error</th>
              </tr>
            </thead>
            <tbody>
              {trades.map((t) => (
                <tr key={t.id} className="border-b border-border/60">
                  <td className="py-1 pr-3 text-fg-muted">{t.id}</td>
                  <td className="py-1 pr-3 text-fg-muted">
                    {fmtTime(t.entry_time ?? t.created_at)}
                  </td>
                  <td
                    className={`py-1 pr-3 uppercase ${statusStyles[t.status] ?? ""}`}
                  >
                    {t.status}
                  </td>
                  <td className="py-1 pr-3">{t.symbol}</td>
                  <td
                    className={`py-1 pr-3 uppercase ${t.direction === "buy" ? "text-success" : t.direction === "sell" ? "text-danger" : "text-fg-muted"}`}
                  >
                    {t.direction}
                  </td>
                  <td className="py-1 pr-3 text-right">
                    {(t.filled_lot ?? t.requested_lot).toFixed(2)}
                  </td>
                  <td className="py-1 pr-3 text-right">
                    {t.fill_price !== null ? t.fill_price.toFixed(5) : "—"}
                  </td>
                  <td className="py-1 pr-3 text-right text-fg-muted">
                    {t.exit_price !== null ? t.exit_price.toFixed(5) : "—"}
                  </td>
                  <td
                    className={`py-1 pr-3 text-right ${
                      t.pnl_currency === null
                        ? "text-fg-muted"
                        : t.pnl_currency >= 0
                          ? "text-success"
                          : "text-danger"
                    }`}
                  >
                    {t.pnl_currency === null
                      ? "—"
                      : `${t.pnl_currency >= 0 ? "+" : ""}${t.pnl_currency.toFixed(2)}`}
                  </td>
                  <td className="py-1 pr-3 text-fg-muted">
                    {t.mt5_ticket ?? "—"}
                  </td>
                  <td className="py-1 pr-3 text-danger text-xs truncate max-w-xs">
                    {t.error ?? ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
